import { ModalContent, ModalFooter } from '@components/modal';
import { Alert } from '@trussworks/react-uswds';
import UserCard from '@src/app-components/user-card/UserCard';
import { useQuery } from '@tanstack/react-query';
import { AUTHORIZED_USER_QUERY_KEYS, AuthorizedUserQueries } from '@src/api/services/authorized-user';
import InternalLink from '@src/app-components/internal-link/InternalLink';
import { PermissionsInfoAlert } from '../components/PermissionsInfoAlert';
import LabelValue from '@components/label-value/LabelValue';
import { UserPermissions } from '@src/utils/enums';
import { useUserProfile } from '@hooks';

const ProjectOwnerModal = ({ projectName, requestType, requestId, version }) => {
  const { userProfileData } = useUserProfile();
  const profileEmail = userProfileData?.emailAddress?.toLowerCase();

  const { data: users = [], isLoading } = useQuery({
    queryKey: [AUTHORIZED_USER_QUERY_KEYS.GET_PROJECT_OWNER_AND_CURRENT_USER_PERMISSIONS, requestId, version],
    queryFn: () => AuthorizedUserQueries.getProjectOwnerAndCurrentUserPermissions(requestId, version),
    staleTime: 0, //Refresh on modal open
  });

  const projectOwner = users?.find((user) => user?.permission === UserPermissions.Owner);
  const currentUser = users?.find((user) => user.email?.toLowerCase() === profileEmail);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <ModalContent title='View Project Owner'>
      <section className='modal-body'>
        <>
          <div className='pn-info-container'>
            <section className='pn-section flex-item'>
              <h3>Details</h3>
              <div className='pn-flex-container'>
                <div className='pn-flex-item'>
                  <LabelValue label='Project Name' value={projectName} />
                </div>
                <div className='pn-flex-item'>
                  <LabelValue
                    label='Project Owner'
                    value={`${projectOwner?.firstName ?? ''} ${projectOwner?.lastName ?? ''}`}
                  />
                </div>
              </div>
              <div className='pn-flex-container'>
                <div className='pn-flex-item'>
                  <LabelValue label='Request Type' value={requestType} />
                </div>
                <div className='pn-flex-item'>
                  <LabelValue
                    label='Project Owner Email'
                    value={
                      <InternalLink
                        content={projectOwner?.email ?? ''}
                        title={`MailTo ${projectOwner?.email ?? ''}`}
                        href={`mailto:${projectOwner?.email ?? ''}`}
                      />
                    }
                  />
                </div>
              </div>
              <Alert headingLevel='h5' type='info' noIcon slim>
                Please contact the project owner listed above for any changes to project details, permissions or to add
                any additional requests.
              </Alert>
            </section>
            <section className='pn-section flex-item'>
              <h3>Your Request Permissions</h3>
              <div className='pn-flex-container'>
                <div className='pn-flex-item'>
                  <div className='user-card-container'>
                    <div className='margin-bottom-1'>
                      <UserCard user={currentUser} showSelectRole={false} />
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className='pn-section'>
              <PermissionsInfoAlert />
            </section>
          </div>
        </>
      </section>
      <ModalFooter saveText='Close' />
    </ModalContent>
  );
};

export default ProjectOwnerModal;
